import { SellerMemberFragment } from '@gql'
import { createModel } from '../../../store/generic'

export default createModel<SellerMemberFragment>()
